import React from "react";

export function buildFilters (data) {
  let filters = {};
  Object.keys(data).forEach(item => {
    filters[item] = data[item].map(val => {
      return {value: val, label: val};
    })
  });
  return filters;
}

export function buildFinderFilters(aggregations) {
  const filters_keys = ['group', 'category', 'lineup', 'series'];
  let filters = {};
  filters_keys.forEach(item => {
    filters[item] = [];
    if (Object.prototype.hasOwnProperty.call(aggregations, item)) {
      filters[item] = aggregations[item].map(val => {
        return val.key;
      });
      filters[item] = filters[item].sort(function(a,b) {
        if (parseFloat(a) && parseFloat(b)) {
          const a_val = parseFloat(a);
          const b_val = parseFloat(b);
          if (a_val < b_val) {
            return -1;
          }
          if (a_val > b_val) {
            return 1;
          }
          return 0;
        }
        if (a < b) {
          return -1;
        }
        if (a > b) {
          return 1;
        }
        return 0;
      });
    }
  });
  return filters;
}

/**
 * @desc Sorts the values of the given items by size
 * @param item
 * @return {*}
 */
function sortValues(item) {
  item.values = item.values.sort(function(a,b) {
    if (parseFloat(a.key) && parseFloat(b.key)) {
      const a_val = parseFloat(a.key);
      const b_val = parseFloat(b.key);
      if (a_val < b_val) {
        return -1;
      }
      if (a_val > b_val) {
        return 1;
      }
      return 0;
    }
    if (a.key < b.key) {
      return -1;
    }
    if (a.key > b.key) {
      return 1;
    }
    return 0;
  });

  return item;
}


/**
 * @desc Builds the filters for the left hand side filter area
 * @param filters
 * @param meta
 * @return {*}
 */
function formatFilters(filters, meta) {

  const filterMap = new Map(); // This means one more allocation + loop, but grants us linear lookup time later on
  meta.forEach(filter => filterMap.set(filter.key, filter));

  return filters.reduce((accumulator, filterEntry) => {
    const filterKey = filterEntry.attribute_key;
    const filterType = filterEntry.filter_type;
    const filterLabel = filterEntry.label
    const rawFilter = filterMap.get(filterKey);

    if (rawFilter) {
      sortValues(rawFilter);

      const formattedFilter = {
        ... rawFilter,
        isOpen: false,
        valuesRange: rawFilter.values.map(attribute => {
          return {value: attribute.key};
        }),
        values: rawFilter.values.map(attribute => {
          return {value: attribute.key, label: attribute.key};
        })
      };

      if (filterType) {
        formattedFilter.filter_type = filterType;
      }
      if (filterLabel) {
        formattedFilter.label = filterLabel;
      }

      // Todo: Remove once BE is updated accordingly
      delete formattedFilter.show_in_list;
      delete formattedFilter.sortable_value;
      //

      accumulator.push(formattedFilter);
    }

    return accumulator;
  }, []);
}


/**
 * @deprecated
 * @param meta
 * @param attributeList
 * @param selectedAttributes
 * @return {*}
 *
 * @Todo Remove once BE is updated accordingly
 */
function formatFiltersDeprecated(meta, attributeList, selectedAttributes) {
  console.debug("Utils.formatFiltersDeprecated");
  const sortedMeta = meta.sort(function(a, b) {
    for (let i = 0; i < attributeList.length; i++) {
      if (attributeList[i][0] === a.key) {
        return -1;
      }
      if (attributeList[i][0] === b.key) {
        return 1;
      }
    }
    return 0;
  });

  const filteredMeta = sortedMeta.filter(element => element.show_in_list === 1);

  return filteredMeta.map(item => {
    if (!Object.prototype.hasOwnProperty.call(selectedAttributes, item.key) && item.values.length < 2) {
      return null;
    }

    sortValues(item);

    // FOR DEVELOPMENT USE ONLY!!!
    // These values need to be fetched from the API. Currently they are
    // hard-coded for development purposes.

    const unit = () => {
      const rand = Math.ceil(Math.random() * 100);

      if (rand < 33) {
        return 'W';
      } else if (rand >=33 && rand < 66) {
        return 'F';
      } else if (rand >= 66) {
        return 'Ω';
      }
    };

    const type = () => {
      const rand = Math.ceil(Math.random() * 100);

      if (rand < 50) {
        return 'range_slider';
      } else if (rand >=50) {
        return 'select';
      }
    };

    const valuesRange = () => {
      const rand = Math.ceil(Math.random() * 100);

      return Array(rand).fill({value: 0}).map((item, index) => {
        return {
          value: index === 0 ? rand : (index + 1) * rand
        };
      });
    };

    const isOpen = () => {
      const rand = Math.ceil(Math.random() * 100);

      if (rand < 50) {
        return false;
      } else if (rand >=50) {
        return true;
      }
    }

    // FOR DEVELOPMENT USE ONLY!!! ./end

    return {
      key: item.key,
      label: item.label,
      unit: item.unit,
      filter_type: item.filter_type,
      isOpen: item.isOpen,
      valuesRange: item.values.map(attribute => {
        return {value: attribute.key};
      }),
      values: item.values.map(attribute => {
        return {value: attribute.key, label: attribute.key};
      })
    }
  });
}


/**
 * @desc Builds the filters for the left side
 * @param meta
 * @param selectedAttributes
 * @param attributeList
 * @param filters
 * @return {*}
 *
 * @Todo Remove deprecated code path once BE is updated accordingly
 */
export function buildRefineFilters(meta, selectedAttributes, attributeList, filters = []) {
  if (filters.length > 0) {
    return formatFilters(filters, meta);
  } else {
    return formatFiltersDeprecated(meta, attributeList, selectedAttributes);
  }
}

export const arraysEqual = (a1, a2) =>
  a1.length === a2.length && a1.every((o, idx) => objectsEqual(o, a2[idx]));

export const objectsEqual = (o1, o2) =>
  typeof o1 === 'object' && Object.keys(o1).length > 0
    ? Object.keys(o1).length === Object.keys(o2).length
    && Object.keys(o1).every(p => objectsEqual(o1[p], o2[p]))
    : o1 === o2;
